import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../_utils/modal';
import Button from '../../_common/button';

export default function PhotoRemoveConfirmationModal({
  className,
  title,
  isOpen,
  onRemove,
  onClose,
}) {
  return (
    <>
      <Modal
        className={`mx-2 ${className}`}
        maxWidth={500}
        open={isOpen}
        onClose={onClose}
        title={title}
        actions={
          <>
            <Button
              text="Cancel"
              className="btn btn-link"
              data-dismiss="modal"
              type="button"
              aria-label="Cancel without removing this photo"
              onClick={onClose}
            />
            <Button
              text="Remove"
              className="btn btn-primary btn-remove"
              data-dismiss="modal"
              type="button"
              aria-label="Remove this photo"
              onClick={onRemove}
            />
          </>
        }
      />
    </>
  );
}

PhotoRemoveConfirmationModal.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

PhotoRemoveConfirmationModal.defaultProps = {
  className: '',
};
